import { ofType } from 'redux-observable';
import { from, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import {
  getBOPISFreeGiftAvailabilityStoresFailed,
  getBOPISFreeGiftAvailabilityStoresSuccess
} from '@redux/actions/bopis/getBOPISFreeGiftAvailabilityStores';
import { GET_BOPIS_FREE_GIFT_AVAILABILITY_STORES_START } from '@redux/actions/bopis/getBOPISFreeGiftAvailabilityStores/types';
import { postAsObservable } from '@services/genericService';

import { GET_AVAILABILITY_STORES_ENDPOINT } from '../getAvailabilityStores/configs';

const getBOPISFreeGiftAvailabilityStoresEpic = (action$) => action$.pipe(
  ofType(GET_BOPIS_FREE_GIFT_AVAILABILITY_STORES_START),
  switchMap((action) => {
    const payload = {
      ListProducts: [...action.payload.ListProducts],
      Type: action.payload.Type
    };

    return from(postAsObservable(GET_AVAILABILITY_STORES_ENDPOINT, payload))
      .pipe(
        map((res) => {
          if (res.status === 200) {
            return getBOPISFreeGiftAvailabilityStoresSuccess(res.data);
          }

          return getBOPISFreeGiftAvailabilityStoresFailed('Failed');
        }),
        catchError((error) => of(getBOPISFreeGiftAvailabilityStoresFailed(error.message || 'Failed')))
      );
  })
);

export default getBOPISFreeGiftAvailabilityStoresEpic;